export default "__VITE_ASSET__CaMlQ0yy__"